import React from 'react'
import SimpleBar from 'simplebar-react'
import { cloneDeep } from 'lodash'

import './Form.scss'

import { FORM_KEYS, DEFAULT_FORM_FIELDS } from '../../constants'

import Checkbox from '../../../../../../../../common/components/Form/Checkbox/Checkbox'
import TextInput from '../../../../../../../../common/components/Form/TextInput/TextInput'
import TextArea from '../../../../../../../../common/components/Form/TextArea/TextArea'

import Preview from './components/Preview/Preview'

const Form = ({ structure, fields = null, colorTheme, t, validateErrors, methods: { updateStructure } }) => {
    const updateField = (key, v, isRequired = false) => {
        let tmpFields = cloneDeep(structure.form.fields)
        if (v) {
            tmpFields.push({
                key,
                isRequired,
            })
            const sortArray = Object.keys(fields || DEFAULT_FORM_FIELDS)
            tmpFields.sort((a, b) => sortArray.indexOf(a.key) - sortArray.indexOf(b.key))
        } else {
            tmpFields = tmpFields.filter(el => el.key !== key)
        }
        updateStructure({ [FORM_KEYS.fields]: tmpFields })
    }

    return (
        <div className="lead-form__form">
            <div className="lead-form__form__workplace-wrapper">
                <SimpleBar autoHide={false} style={{ maxHeight: '100%' }}>
                    <div className="lead-form__form__workplace">
                        <h3 className="lead-form__form__workplace-title">{t('Form')}</h3>
                        <div className="lead-form__form__workplace-content">
                            <div className="fields">
                                <p>{t('Show fields')}:</p>
                                <ul>
                                    {Object.values(fields || DEFAULT_FORM_FIELDS).map(({ key, label, isRequired }) => (
                                        <li key={key}>
                                            <Checkbox
                                                label={label}
                                                value={structure.form.fields.findIndex(el => el.key === key) !== -1}
                                                onUpdate={v => updateField(key, v, isRequired)}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <TextInput
                                label={t('Header')}
                                value={structure.form.headerText}
                                errorMessages={validateErrors.form.headerText}
                                onUpdate={value => updateStructure({ [FORM_KEYS.headerText]: value })}
                            />
                            <TextArea
                                label={t('Description')}
                                value={structure.form.descriptionText}
                                errorMessages={validateErrors.form.descriptionText}
                                onUpdate={value => updateStructure({ [FORM_KEYS.descriptionText]: value })}
                            />
                            <TextInput
                                label={t('Button text')}
                                isRequired
                                value={structure.form.buttonText}
                                errorMessages={validateErrors.form.buttonText}
                                onUpdate={value => updateStructure({ [FORM_KEYS.buttonText]: value })}
                            />
                            <TextInput
                                label={t('Link to your privacy policy')}
                                value={structure.form.linkPrivacyPolicyLink}
                                errorMessages={validateErrors.form.linkPrivacyPolicyLink}
                                onUpdate={value => updateStructure({ [FORM_KEYS.linkPrivacyPolicyLink]: value })}
                            />
                        </div>
                    </div>
                </SimpleBar>
            </div>
            <div className="lead-form__form__preview-wrapper">
                <SimpleBar autoHide={false} style={{ maxHeight: '100%' }}>
                    <div className="lead-form__form__preview">
                        <p className="lead-form__form__preview-title">{t('Approximate preview')}</p>
                        <Preview
                            colorTheme={colorTheme}
                            fieldsDescription={fields}
                            fields={structure.form.fields}
                            headerText={structure.form.headerText}
                            descriptionText={structure.form.descriptionText}
                            buttonText={structure.form.buttonText}
                            linkPrivacyPolicyLink={structure.form.linkPrivacyPolicyLink}
                        />
                    </div>
                </SimpleBar>
            </div>
        </div>
    )
}

export default Form
